// Pure gating logic for the home page's custom-cursor layer. Kept separate
// from useCapability.js's DOM glue so it's unit-testable without jsdom's
// incomplete matchMedia support getting in the way.
export function computeCapability({ reducedMotion, pointerFine, viewportWidth, smBreakpoint = 600 }) {
  const isMobileWidth = viewportWidth < smBreakpoint;
  const baseOk = !reducedMotion && !isMobileWidth;
  return {
    renderCursor: baseOk && pointerFine,
  };
}
